/*
     The policy of Auth0 password
     It should match requirements in auth0 dashboard - https://manage.auth0.com/dashboard/us/customink/connections/database/con_iI9QZUhOZcn2Buzv/authentication-methods/password
     */
export const validateAuth0PasswordRequirements = (password: string): true | string => {
    return password.length >= 6 || 'Password must be at least 6 characters long';
};
